import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import OnboardingStep from '../components/OnboardingStep';
import { toast } from 'sonner';

const TimeOfBirthNew = () => {
  const navigate = useNavigate();
  const [time, setTime] = useState('');
  
  const handleContinue = () => {
    if (!time) {
      toast.error('Please select your time of birth');
      return;
    }
    
    const birthData = JSON.parse(localStorage.getItem('birthData') || '{}');
    birthData.time = time;
    localStorage.setItem('birthData', JSON.stringify(birthData));
    
    navigate('/place-of-birth');
  };
  
  return (
    <OnboardingStep
      step={3}
      totalSteps={5}
      title="What time were you born?"
      reassurance="If you don't know the exact time, an approximate is fine"
      trustNote="Time of birth affects your rising sign and house placements."
      onContinue={handleContinue}
      continueDisabled={!time}
    >
      <div className="space-y-4">
        <label className="block">
          <span className="text-sm font-medium text-stone-700 mb-2 block">
            Time of Birth
          </span>
          <input
            type="time"
            className="w-full px-4 py-4 rounded-input bg-stone-50 border-2 border-transparent focus:border-cosmic-500 focus:bg-white transition-all text-lg outline-none"
            value={time}
            onChange={(e) => setTime(e.target.value)}
          />
        </label>
        <button className="text-sm text-cosmic-600 hover:text-cosmic-700 transition-colors">
          I don't know my exact time
        </button>
      </div>
    </OnboardingStep>
  );
};

export default TimeOfBirthNew;